import { MissionRewardType } from "../types/mission.type";

const FRONTEND_TO_BACKEND: Record<MissionRewardType, string> = {
  product: "Tmais::Product",
  points: "points",
  tickets: "tickets",
};

const BACKEND_TO_FRONTEND: Record<string, MissionRewardType> = {
  product: "product",
  "Tmais::Product": "product",
  points: "points",
  tickets: "tickets",
  bilhetes: "tickets",
};

export const frontendRewardTypeToBackend = (
  type: MissionRewardType = "product",
) => {
  return FRONTEND_TO_BACKEND[type] || "product";
};

export const backendRewardTypeToFrontend = (
  type?: string,
): MissionRewardType => {
  if (!type) return "product";
  return BACKEND_TO_FRONTEND[type] || "product";
};

export const parseRequirementQuantity = (value?: string | number | null) => {
  if (typeof value === "number") return value;
  if (!value) return 0;
  const cleaned = String(value)
    .replace(/[^0-9.,-]/g, "")
    .replace(",", ".");
  const parsed = parseFloat(cleaned);
  return Number.isFinite(parsed) ? parsed : 0;
};
